/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AwardMedalIcon16Light = forwardRef('AwardMedalIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.715 1.59a.5.5 0 0 1 .697.123l1.593 2.279 1.593-2.279a.5.5 0 1 1 .82.574L8.502 5.025a4.97 4.97 0 0 1 2.228.786l2.867-4.098a.5.5 0 0 1 .82.574L11.51 6.44a5 5 0 1 1-7.017-.006L1.592 2.288a.5.5 0 1 1 .82-.574l2.863 4.094a4.97 4.97 0 0 1 2.231-.783L5.592 2.287a.5.5 0 0 1 .123-.697ZM4 10a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z" })));
});
